import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Aside from "./Aside";
import Footer from "./Footer";
import "./Unauthorized.css";

/**
 * Pantalla de acceso denegado.
 * Nota: muchas rutas montan este componente un instante mientras validan permisos
 * (hasPermission inicia en false). Por eso el diseño es neutro (sin franjas rojas).
 * Iniciativa pendiente: hasPermission=null + Loading hasta validar (ver plan iniciativas).
 */
function Unauthorized() {
    return (
        <div className="hold-transition unauthorized-page">
            <Header />
            <Aside />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12 text-center">
                                <h1 className="m-0 unauthorized-title">
                                    <i className="fas fa-lock" aria-hidden="true"></i> Acceso restringido
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row justify-content-center">
                            <div className="col-md-6">
                                <div className="unauthorized-card">
                                    <div className="unauthorized-card-body text-center">
                                        <div className="unauthorized-icon mb-3">
                                            <i className="fas fa-user-lock" aria-hidden="true"></i>
                                        </div>
                                        <h4 className="unauthorized-heading">No tienes permiso para esta página</h4>
                                        <p className="unauthorized-text">
                                            Tu rol no incluye el acceso necesario. Si crees que es un error,
                                            contacta al administrador de la clínica.
                                        </p>
                                        <div className="mt-4">
                                            <Link to="/home" className="btn btn-primary unauthorized-home-btn">
                                                <i className="fas fa-home"></i> Volver al Inicio
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <Footer />
        </div>
    );
}

export default Unauthorized;
